<template>
    <div class="container section-menu-page">
        <div class="section-title-wrap">
		<h2 class="section-title">{{ titulo }} </h2>
        </div>
        <div>
            <div class="admin-home-card table-corporate-body main-menu-scroll-shell">
                <b-container style="padding: 18px 40px 40px; height: 100%;">
                    <div v-if="listaSubMenu.length > 0" class="menu-grid">
                        <div
                            v-for="subMenu in listaSubMenu"
                            :key="subMenu.id || subMenu.ruta"
                            class="menu-grid-item"
                        >
                            <div class="menu-item-wrapper">
                                <button
                                    type="button"
                                    class="md-card admin-menu-card-button"
                                    @click="goToRoute(subMenu.ruta)"
                                >
                                    <div>
                                        <div>
                                            <div class="md-title-tarjeta">
                                                <span>{{ subMenu?.nombre }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <div class="div-description-fixed">
                                    <i class="fas fa-info-circle info-icon"></i>
                                    <span class="description-text">{{ subMenu?.descripcion || subMenu?.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
import SubMenu from '../../services/SubMenu';

export default {
    name: "Administrador",
    data: () => ({
        titulo: "Administrador",
        listaSubMenu: []
    }),

    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Administrador",
                    users: "Usuarios",
                    usersd: "Administración de Usuarios",
                    menu: "Menús",
                    descripMenu: "Administración de Menús",
                    subMenu: "Submenús",
                    descripSubMenu: "Administración de submenus",
                    roles: "Roles",
                    descripRole: "Administración de Roles",
                    cargues: "Cargues",
                    carguesd: "Definición de formatos de cargues",
                }
            } else {
                return {
                    title: "Administrator",
                    users: "Users",
                    usersd: "Users Administration",
                    menu: "Menus",
                    descripMenu: "Menus Administration",
                    subMenu: "Submenus management",
                    descripSubMenu: "submenus description",
                    roles: "Role",
                    descripRole: "Role Administration",
                    cargues: "Uploads",
                    carguesd: "Upload Format Definition",
                }
            }
        }
    },
    methods: {
        goToRoute(page) {
            this.$router.push({ path: page })
        }
    },
    mounted() {
        SubMenu.nombreMenu(this.$route.name)
            .then((res) => {
                this.titulo = res.data.titulo
            })
            .catch((err) => { console.log(err) })

        SubMenu.subMenuByMenuByRol(this.$route.name, this.$store.state.userRole)
            .then((res) => {
                this.listaSubMenu = res.data.submenus
            })
            .catch((err) => { console.log(err) })
    }
}
</script>

<style src="../main.css"></style>
